<template>
    <div class="container vh-100 d-flex justify-content-sm-center align-items-sm-center">
        <div class="login-container-row row bg-gradient" :class="'bg-' + (!isTheme() || theme == 'light' ? 'light' : `${theme} text-light`)">
            <div class="col-12 col-sm-7 order-1 order-sm-2 login-image">
                <img :src="G.projectLogo" alt="...">
            </div>
            <div class="col-12 col-sm-5 offset-sm-0 order-2 order-sm-1 p-5 d-sm-flex justify-content-sm-center align-items-sm-center">

                <main class="form-signin">
                    <form class="text-center">
                        <!-- <img class="mb-4" src="assets/images/logo.jpg" alt="" width="150" /> -->
                        <h1 class="h3 mb-0 fw-normal">{{ TR.login_title }}</h1>
                        <h1 class="h6 mb-5 fw-normal mt-2" v-html="G.projectName"></h1>

                        <div class="form-floating">
                            <input
                            type="email"
                            class="form-control border-0 border-bottom border-secondary bg-transparent mb-21"
                            :class="'text-' + (!isTheme() || theme == 'light' ? 'dark' : 'light')"
                            id="floatingInput"
                            :autofocus="email == '' ? true : false"
                            autocomplete="off"
                            placeholder=""
                            v-model="email"
                            @keyup.enter="auth"
                            />
                            <label for="floatingInput">{{ TR.username }}</label>
                        </div>
                        <div class="form-floating">
                            <input
                            type="password"
                            class="form-control border-0 border-bottom border-secondary bg-transparent"
                            :class="'text-' + (!isTheme() || theme == 'light' ? 'dark' : 'light')"
                            id="floatingPassword"
                            :autofocus="email == '' ? false : true"
                            autocomplete="off"
                            placeholder=""
                            v-model="password"
                            @keyup.enter="auth"
                            />
                            <label for="floatingPassword">{{ TR.password }}</label>
                        </div>

                        <div class="checkbox my-4">
                            <label class="cursor-pointer">
                                <input type="checkbox" value="xatirla" class="me-1" /> {{ TR.remember }}
                            </label>
                        </div>
                        <button class="w-100 btn btn-lg btn-secondary border-01" type="button" @click="auth">
                            {{ TR.signin }}
                        </button>
                        <p class="mt-5 mb-3" v-html="footerInfo"></p>
                    </form>
                </main>

            </div>
        </div>

    </div>

</template>

<script scoped>
    import { onMounted, ref, watchEffect } from "vue";

    import { useStore } from '@/system_modules/store';

    import { useRouter, useRoute } from "vue-router";
    import { G, ajax } from "@/_common";

    export default {
        name: "LoginContainerImageP",
        props: {
            theme:{
                type: String,
                default: 'dark'
            }
        },
        setup(props) {
            const store = useStore();
            const router = useRouter();
            const route = useRoute();

            const TR = ref({});
            const email = ref("");
            const password = ref("");
            const footerInfo = G.footerPowered; //.replace('footer-info-link', 'text-' + ((props.theme === undefined || props.theme == '') ? 'light' : props.theme));

            watchEffect(() => {
                TR.value = store.getTranslation();
            });

            onMounted(() => {
                email.value = ( G.hasClientData("da_adm_username") ) ? G.getClientData("da_adm_username") : '';
                G.removeClientData("AUTH_TOKEN");
            });

            const isTheme = () => {
                let themes = [
                    'custom',
                    'primary',
                    'secondary',
                    'warning',
                    'danger',
                    'success',
                    'info',
                    'dark',
                ];
                return themes.includes(props.theme);
            };

            const auth = async (e) => {
                e.preventDefault();

                if( email.value != '' && password.value != '' ){
                    let loginData = new FormData();
                    loginData.append("email", email.value);
                    loginData.append("password", password.value);

                    await ajax({
                        method: "post",
                        url: store.getLogin(),
                        data: loginData,
                        success: async (e) => {
                            let res = e.data || null;
                            if (res && res.token && res.token.length > 0) {
                                G.token = res.token;
                                G.setClientData("AUTH_TOKEN", res.token);
                                G.setClientData("da_adm_username", email.value);
                                // let t = G.token_data();
                                // G.userPageAccess.value = [{
                                //     'role': t.role,
                                //     'permission': JSON.parse(t.permission || []),
                                // }];
                                G.parseTokenPermission();

                                if (
                                    route.query &&
                                    route.query.redirect &&
                                    route.query.redirect != ""
                                )
                                    router.push(route.query.redirect);
                                else {
                                    // router.push({name: 'agenda'});
                                    router.push({ path: "/" });
                                    // router.push('/');
                                }
                            }
                        }
                    });
                }
            };

            return {
                G,
                TR,
                email,
                password,
                auth,
                footerInfo,
                isTheme,
            };
        },
    };
</script>

<style lang="scss">
.login-container-row{
    padding: 5rem 4rem;
}
.login-image{
    text-align: center;
}
.login-image img{
    object-fit: contain;
    height: 100%;
}
.form-signin {
    width: 100%;
}
.form-signin input {
    background: transparent;
    border-radius: 0;
}
.form-signin .form-floating>label {
    color: rgb(170, 169, 169) !important;
}
.footer-info-link{
    color: v-bind(theme) !important;
}
@media(max-width: 576px){
    .login-container-row{
        padding: 0;
    }
    .login-image img{
        width: 50%;
        text-align: center;
        justify-content: center;
        align-self: center;
    }
}
</style>